export default "__VITE_ASSET__BIaXmKFk__"